import React from 'react';
import styles from './PaymentInfoContainer.module.scss';

/* Assets */
import SVG from 'react-inlinesvg';
import closeIcon from '../../../../assets/icons/close.svg';

/* Components */
import { Elements } from 'react-stripe-elements';
import { PaymentInfoItem } from '../PaymentInfoItem/PaymentInfoItem';
import { SuccessModal } from '../../../Shops/shared/components/ProductContainer/SuccessModal';
import { FailureModal } from '../../../Shops/shared/components/ProductContainer/FailureModal';

/* Interfaces */
import { PaymentType } from '../../interfaces/payment_types';
import { StoreTypesReversed } from '../../interfaces/store_types';

/* Custom Hooks */
import { usePaymentInfoContainer } from '../../__hooks__/usePaymentInfoContainer';

/* Providers */
import { usePaymentTypeContext } from '../../__providers__/PaymentTypeContext';
import {
  PurchaseStatus,
  usePurchaseStatusProvider,
} from '../../../Shops/shared/__providers__/PurchaseStatusProvider';
import { useStoreContext } from '../../__providers__/StoreContext';
import { usePaymentProvider } from '../../__providers__/PaymentProvider';
import { PixPaymentProcessor } from '../../interfaces/PixPaymentProcessor';
import { useShopContext } from '../../../Shops/shared/__providers__/ShopContext';

interface PaymentInfoContainerProps {}

export const PaymentInfoContainer: React.FC<PaymentInfoContainerProps> = () => {
  const {
    states: { payments },
  } = usePaymentInfoContainer();
  const { store } = useStoreContext();
  const { selectedPayment } = usePaymentTypeContext();
  const { shop } = useShopContext();

  const { isPendingModalOpen, setIsPendingModalOpen, purchaseID, processor } =
    usePaymentProvider();

  return (
    <>
      {isPendingModalOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal} style={{ maxWidth: '300px' }}>
            <a // eslint-disable-line
              onClick={() => setIsPendingModalOpen(false)}
              className={styles.close}
            >
              <SVG src={closeIcon} />
            </a>

            <h1>Pagamento pendente</h1>
            <p>Para comprovar a compra clique no botão</p>
            <button
              type="button"
              className={styles.pixBtnModal}
              onClick={() =>
                (processor as PixPaymentProcessor).finishPayment(
                  store,
                  purchaseID,
                  shop!,
                )
              }
            >
              Comprovar
            </button>
          </div>
        </div>
      )}

      <div className={styles.container}>
        {payments.map((payment: PaymentType) => {
          return selectedPayment === payment ? (
            <Elements key={payment}>
              <PaymentInfoItem />
            </Elements>
          ) : null;
        })}
      </div>
    </>
  );
};
